import React from 'react';

import { QueryContainer } from '@components/QueryContainer';
import { DeliveryInstructionEditDisplay } from '@components/utilities/Bookings/DeliveryInstructionEditDisplay';
import { useDeliveryInstruction } from '@hooks/queries/useDeliveryInstruction';
import { useUser } from '@hooks/queries/useUser';
import { useOpenInVscode } from '@hooks/useOpenInVscode';
import { useSearch } from '@hooks/useSearch';
import * as t from 'io-ts';
import { useHistory } from 'react-router-dom';
import * as h from 'tyrann-io';

const searchType = t.type({
  from: h.omittable(h.string()),
  d2dNo: h.string(),
});

export const DeliveryInstruction: React.FC = () => {
  const {
    search: { from, d2dNo },
  } = useSearch(searchType);

  const history = useHistory();
  const deliveryInstruction = useDeliveryInstruction(d2dNo);
  const user = useUser();
  const data = deliveryInstruction.data!;

  if (import.meta.env.DEV) {
    useOpenInVscode();
  }

  return (
    <QueryContainer queries={[deliveryInstruction, user]}>
      {() => (
        <DeliveryInstructionEditDisplay
          user={user.data!}
          d2dNo={d2dNo}
          deliveryInstruction={data}
          type="client"
          onGoBack={() => history.push(from ?? '')}
        />
      )}
    </QueryContainer>
  );
};
